import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import OrderResultRecord from "../../api/OrderResults/OrderResultModel/OrderResultRecord"
import Stage from "../../api/OrderResults/OrderResultModel/Stage"
import { Status } from "../../api/OrderResults/OrderResultModel/Status"

const stepStatusColor = (stage: Stage, showCompleteOrders: boolean) => {
  // TODO: code below was ported from angular application, refactor into meaningful class names (e.g. success, warning error etc)
  if (stage.Status === Status.None) {
    return "status-none"
  }
  if (stage.Status === Status.Completed) {
    return showCompleteOrders ? "status-completed-close": "status-completed"
  }
  if (stage.Status === Status.InProcess) {
    return "status-in-progress"
  }
  if (stage.Status === Status.Alert) {
    return "status-alert"
  }
  if (stage.Status === Status.Cancelled) {
    return "status-no-status"
  }
  if ((stage.Status === Status.NoStatus) || (showCompleteOrders && stage.Status !== Status.Completed)) {
    return "status-no-status"
  }
}

const stepStatusClass = (stage: Stage) => {
  let results = ["px-1 step"]
  if ((stage.Sequence !== 1) && (stage.Status === Status.Completed || stage.Status === Status.InProcess || stage.Status === Status.Alert)) {
    results.push("step-line")
  }
  return results.join(' ')
}

export default function GridStatusInfo(props: {value: OrderResultRecord, showCompleteOrders: boolean}) {
  if (!props.value.Stages) {
    return <></>
  }
  const stages: Stage[] = props.value.Stages
  const complete = props.showCompleteOrders
  const scheduleStatusId = props.value.ScheduleStatusID
  const testEventStatus = props.value.TestEventStatus
  const testDetailClinicalId = props.value.TestDetailClinicalID || ""
  const showEventStatus = (scheduleStatusId > 0) && (testDetailClinicalId != "") && (testEventStatus === "Cancelled")

  return (
    <>
      <Container className="d-none d-sm-block">
        {stages.map((stage: Stage, key: number) => {
          if (stage.IsStatusVisible) {
            return (
              <Row key={key}>
                <Col className={stepStatusColor(stage, complete) + " " + stepStatusClass(stage)}>
                  <span className="numbers mr-2">{complete && stage.Status !== 1 ? 'X' : stage.Sequence}</span>
                  <span className="montserrat-regular">{showEventStatus? testEventStatus : stage.StatusDetail.Description}</span>
                  <span className="status-details">{stage.StatusDetail.Detail}</span>
                </Col>
              </Row>
            )
          } else {
            return <Row key={key}>{stage.Name}</Row>
          }
        })}
      </Container>
      <Container className="d-block d-sm-none">
        {stages.slice(-2).map((stage: Stage, key: number) => {
          if (stage.IsStatusVisible) {
            return (
              <div key={key}>
                <Row>
                  {stage.Name}
                </Row>
                <Row className="color-status">
                  <Col className={stepStatusColor(stage, complete)}></Col>
                </Row>
              </div>
            )
          } else {
            return <Row key={key}>{stage.Name}</Row>
          }
        })}
      </Container>
    </>
  )
}
